'use client';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { Plus, FileText, Users, Package } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useCompany } from '@/contexts/CompanyContext';

export default function DashboardHeader() {
  const { user } = useAuth();
  const { activeCompany } = useCompany();
  const [greeting, setGreeting] = useState('Good morning');
  const [dateStr, setDateStr] = useState('');

  useEffect(() => {
    const hour = new Date()?.getHours();
    if (hour < 12) setGreeting('Good morning');
    else if (hour < 17) setGreeting('Good afternoon');
    else setGreeting('Good evening');

    setDateStr(new Date()?.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }));
  }, []);

  const userName = user?.user_metadata?.full_name || user?.email?.split('@')?.[0] || 'there';
  const companyName = activeCompany?.companyName || 'your company';

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex items-center gap-4">
        {activeCompany?.logoUrl && (
          <img
            src={activeCompany?.logoUrl}
            alt={`${activeCompany?.companyName} logo`}
            className="h-12 w-auto object-contain rounded-lg border border-border hidden sm:block"
          />
        )}
        <div>
          <h1 className="text-3xl font-800 text-foreground tracking-tight">
            {greeting}, {userName} 👋
          </h1>
          <p className="text-muted-foreground text-sm mt-1">
            Here&apos;s what&apos;s happening with <span className="text-foreground font-500">{companyName}</span> today —{' '}
            {dateStr && <span className="text-foreground font-500">{dateStr}</span>}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <Link href="/invoice-generator" className="btn-primary text-sm py-2.5 px-4">
          <Plus size={15} />
          New Invoice
        </Link>
        <Link href="/quotation-generator" className="btn-secondary text-sm py-2.5 px-4">
          <FileText size={15} />
          Quotation
        </Link>
        <Link href="/customer-management" className="btn-secondary text-sm py-2.5 px-4">
          <Users size={15} />
          Customer
        </Link>
        <Link href="/product-management" className="btn-secondary text-sm py-2.5 px-4">
          <Package size={15} />
          Product
        </Link>
      </div>
    </div>
  );
}